import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "points-log" }
const _hoisted_2 = { class: "points-toolbar" }
const _hoisted_3 = { class: "points-range" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "积分流水", -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.rangeHint), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
          return (_openBlock(), _createElementBlock("button", {
            key: preset.days,
            type: "button",
            class: _normalizeClass(['points-range__preset', { 'points-range__preset--active': _ctx.selectedPreset === preset.days }]),
            onClick: ($event: any) => (_ctx.applyPreset(preset.days))
          }, _toDisplayString(preset.label), 11, _hoisted_4))
        }), 128)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
          type: "date",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPreset = 0))
        }, null, 544), [
          [_vModelText, _ctx.startDate]
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "至", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
          type: "date",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPreset = 0))
        }, null, 544), [
          [_vModelText, _ctx.endDate]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "points-range__apply",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
        }, "应用")
      ])
    ]),
    _createVNode(_component_DataTable, {
      columns: _ctx.columns,
      "data-source": _ctx.transactions,
      loading: _ctx.loading,
      total: _ctx.total,
      current: _ctx.page,
      "page-size": _ctx.pageSize,
      "empty-text": "暂无积分流水",
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'user')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.nickname || record.email || record.username || record.user_id), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'amount')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass({ 'admin-amount--positive': record.amount > 0, 'admin-amount--negative': record.amount < 0 })
            }, _toDisplayString(record.amount > 0 ? '+' : '') + _toDisplayString(record.amount), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "total", "current", "page-size", "onChange"])
  ]))
}